module.exports = __webpack_public_path__ + "static/media/vn.15531ca8.svg";